module.exports = __webpack_public_path__ + "static/media/brandon_profile.f70d236a.jpg";